import { api } from '@/lib/api';
import type {
  ArchiveTaxonomyPayload,
  CreateTaxonomyPayload,
  ReorderTaxonomyPayload,
  Taxonomy,
  TaxonomyKind,
  UpdateTaxonomyPayload,
} from './types';

export const taxonomyApi = {
  list: async (
    kind: TaxonomyKind,
    options: { includeArchived?: boolean } = {},
  ): Promise<Taxonomy[]> => {
    const { data } = await api.get<Taxonomy[]>('/taxonomy', {
      params: { kind, includeArchived: options.includeArchived ?? false },
    });
    return data;
  },
  getById: async (id: string): Promise<Taxonomy> => {
    const { data } = await api.get<Taxonomy>(`/taxonomy/${id}`);
    return data;
  },
  create: async (input: CreateTaxonomyPayload): Promise<Taxonomy> => {
    const { data } = await api.post<Taxonomy>('/taxonomy', input);
    return data;
  },
  update: async (
    id: string,
    input: UpdateTaxonomyPayload,
  ): Promise<Taxonomy> => {
    const { data } = await api.patch<Taxonomy>(`/taxonomy/${id}`, input);
    return data;
  },
  archive: async (
    id: string,
    input: ArchiveTaxonomyPayload = {},
  ): Promise<Taxonomy> => {
    const { data } = await api.post<Taxonomy>(`/taxonomy/${id}/archive`, input);
    return data;
  },
  restore: async (id: string): Promise<Taxonomy> => {
    const { data } = await api.post<Taxonomy>(`/taxonomy/${id}/restore`, {});
    return data;
  },
  reorder: async (
    input: ReorderTaxonomyPayload,
  ): Promise<{ updated: number }> => {
    const { data } = await api.post<{ updated: number }>(
      '/taxonomy/reorder',
      input,
    );
    return data;
  },
};
